import SectionHeading from "./SectionHeading";

const principles = [
  {
    icon: "ri-heart-3-line",
    title: "真诚交流",
    desc: "把真实的热爱带进每一次讨论，理性表达，温柔相待。",
  },
  {
    icon: "ri-shield-check-line",
    title: "友善守护",
    desc: "尊重每一位同好与创作者，共同守护这片温暖的交流空间。",
  },
  {
    icon: "ri-star-smile-line",
    title: "内容为先",
    desc: "坚持输出有价值、有温度的讨论与推荐，让分享更有意义。",
  },
];

const values = [
  { label: "同好", value: "找同好", icon: "ri-user-heart-line" },
  { label: "剧情", value: "聊剧情", icon: "ri-chat-smile-2-line" },
  { label: "创作", value: "分享创作", icon: "ri-palette-line" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="一个属于同好的温暖角落"
              align="left"
              desc="腐漫网是面向腐向内容爱好者与同好人群的互动社区平台。我们相信，热爱值得被好好安放——无论是热闹的讨论、走心的安利，还是深夜的一句共鸣，都能在这里找到归属。"
            />

            <div className="mt-8 flex flex-col gap-3">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-3xl">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20a%20cozy%20cozy%20reading%20lounge%20filled%20with%20friends%20talking%20and%20sharing%20books%20and%20sketchbooks%20over%20tea%20by%20a%20sunlit%20window%2C%20cherry%20blossom%20branches%20outside%2C%20rose%20and%20gold%20tones%2C%20welcoming%20fandom%20community%20atmosphere&width=1200&height=900&seq=about-community&orientation=landscape"
                alt="腐漫网同好社区 - 温暖的交流阅读空间"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-background-50/90 p-4 backdrop-blur-sm">
                <p className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  我们相信，热爱值得被好好安放
                </p>
                <p className="mt-1 text-xs text-foreground-600">
                  每一份分享与共鸣，都让这个社区更温暖一点点。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {values.map((v) => (
                <div key={v.label} className="flex flex-col items-center gap-2 rounded-2xl border border-background-200 bg-background-50 p-4 text-center">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{v.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}